const { popupImage } = require('./modules/modal');
const { pageTop } = require('./modules/pageTop');
const { scrollmagic } = require('./modules/scrollmagic');
const { smooth } = require('./modules/smooth');

popupImage();
pageTop();
scrollmagic();
smooth();
